import axios from 'axios'
import { gengetURLTEST, genURL } from "../../_getjson";

export default async function Checkdocgroup(code, tablename, search) {
    console.log(search);
    if (code) {
        let rs = "";
        //https://psaccmdapi.pspl.co.th/CSDOCGROUP/Docgroupaspermission?tablename=CSSALE&txtsearch=&usercode=51778&typesearch=undefined&top=300&sitecode=&api_key=JmeD3lEvTKVOp0pKPJwHsbGKGDAdZlo5cwbrhsYc&jwt=eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJleHAiOjE2NTQ3Nzg4OTAsIlVzZXIiOnsiQ09ERSI6IjUxNzc4IiwiU0lURUNPREUiOiIiLCJVU0VSR1JPVVAiOiIifX0.Mx9nPUH6CTLo4pSFs3UuDEfS_y_apdpwfhzAdknVyFU
        // เส้นทาง APIเดิม var Url = "CSDOCGROUPUSER/Getdata?tablename=" + tablename + "&Code=" + code + "&Usercode=" + localStorage.getItem("Username") + "&top=300"
        //แก้ไขวันที่ 9-6-65  เปลี่ยเส้นทาง API
        let Url = "CSDOCGROUP/Docgroupaspermission?tablename=" + tablename + "&usercode=" + localStorage.getItem("Username") + "&typesearch=0&txtsearch=" + code + "&top=300"

        console.log("ssssss", genURL(Url));
        await axios.get(genURL(Url), { timeout: 5000 }).then((res) => {
            if (res.data.length === 1) {
                rs = res.data[0].MYNAMETH
            }
        }).catch((err) => {
            console.log(err);
        });
        return rs
    }
};